import { EmbedPlaylist } from 'libs/index';
import withValidation from 'libs/lead-capture-form/utils/withValidation';
import { withViewer } from 'libs/wrapper/withViewer';

import { useEnterpriseSiteRedirect } from '@vimeo/enterprise-site-redirect';
import { useViewer } from '@vimeo/viewer';

const EmbedPage = () => {
  const viewer = useViewer();

  useEnterpriseSiteRedirect(viewer?.teamUser?.enterpriseSiteDomain);

  return <EmbedPlaylist hasInteractivityTools={false} />;
};

export default withValidation(withViewer(EmbedPage));
